import AgentDetailCard from "./AgentDetailCard";
import { useTranslation } from "react-i18next";

export default function AgentInfoCard({ policyDetail }) {
  const { t } = useTranslation();
  return (
    <>
      {policyDetail.agents?.servicingAgents && (
        <AgentDetailCard
          cardTitle={t("AgentInfoCard-card-title-1")}
          agents={policyDetail.agents?.servicingAgents}
        />
      )}
      {policyDetail.agents?.writingAgents && (
        <AgentDetailCard
          cardTitle={t("AgentInfoCard-card-title-2")}
          agents={policyDetail.agents?.writingAgents}
        />
      )}
    </>
  );
}
